package app.nestbridge.feature.invitations.ui

import androidx.compose.foundation.background
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.auth.model.OtpChannel
import com.karawek.core.auth.screen.OtpVerificationState
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.ThemeMode
import com.karawek.core.ui.theme.ThemeModeProvider
import app.nestbridge.feature.invitations.screen.InvitationOtpVerificationScreen
import app.nestbridge.app.ui.OtpVerificationContent
import app.nestbridge.ui.theme.NestBridgeTheme
import com.slack.circuit.codegen.annotations.CircuitInject
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.tooling.preview.PreviewParameter
import software.amazon.lastmile.kotlin.inject.anvil.AppScope

@CircuitInject(
    screen = InvitationOtpVerificationScreen::class,
    scope = AppScope::class,
)
@Composable
fun InvitationOtpVerificationUi(
    state: OtpVerificationState,
    modifier: Modifier = Modifier,
) {
    OtpVerificationContent(state = state, modifier = modifier)
}

// region Previews

@Preview
@Composable
private fun InvitationOtpVerificationPreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    NestBridgeTheme(themeMode = themeMode) {
        InvitationOtpVerificationUi(
            state = OtpVerificationState(
                channel = OtpChannel.Phone,
                destination = "312-555-1212",
            ),
            modifier = Modifier.background(color = CoreTheme.colors.background),
        )
    }
}

@Preview
@Composable
private fun InvitationOtpVerificationWithCodePreview(
    @PreviewParameter(ThemeModeProvider::class) themeMode: ThemeMode,
) {
    NestBridgeTheme(themeMode = themeMode) {
        InvitationOtpVerificationUi(
            state = OtpVerificationState(
                channel = OtpChannel.Phone,
                otpCode = "123456",
                destination = "312-555-1212",
            ),
            modifier = Modifier.background(color = CoreTheme.colors.background),
        )
    }
}

// endregion
